import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';
import { registerSteps } from '../../constants';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { Divider } from '@/components/Divider';
import { TRedirectData } from '../../types';

interface IAccountAlreadyExistsBottomsheetProps {
  currentStepPayload: TRedirectData;
  handleRegisterLogic: (__data: TRedirectData) => void;
}

const AccountAlreadyExistsBottomsheet: FC<
  IAccountAlreadyExistsBottomsheetProps
> = ({ currentStepPayload, handleRegisterLogic }) => {
  const handleCtaAction = (shouldLogin: boolean) => {
    const redirectData = {
      nextStep: shouldLogin
        ? registerSteps?.MofidLogin
        : registerSteps?.MofidOtp,
      requestToken: currentStepPayload?.requestToken,
    };
    handleRegisterLogic(redirectData);
    BottomSheet.close();
  };

  return (
    <div className="flex flex-col gap-y-6">
      <Text color="gray-120" size="sm" weight="regular">
        {currentStepPayload?.message?.message}
      </Text>
      <Divider />
      <div className="flex flex-col gap-y-2 md:flex-row md:gap-x-2">
        <Button
          className="w-full md:w-1/2"
          onClick={() => handleCtaAction(false)}
        >
          ویرایش شماره موبایل
        </Button>
        <Button
          className="w-full md:w-1/2"
          variant="link"
          onClick={() => handleCtaAction(true)}
        >
          ورود به مفید
        </Button>
      </div>
    </div>
  );
};

export const openAccountAlreadyExistsBottomsheet = (
  currentStepPayload: TRedirectData,
  handleRegisterLogic: (__data: TRedirectData) => void
) => {
  return BottomSheet.open({
    children: (
      <AccountAlreadyExistsBottomsheet
        currentStepPayload={currentStepPayload}
        handleRegisterLogic={handleRegisterLogic}
      />
    ),
    closeAction: () => {},
  });
};
